import { carouselItems } from '@/mocks/home';

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-2">焦点专题</h2>
          <p className="text-sm text-foreground-500">深度策划的专题内容，为你全景呈现热门事件</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {carouselItems.map((item) => (
            <article key={item.title} className="rounded-2xl overflow-hidden bg-background-50 border border-background-200 hover:border-primary-200 transition-all cursor-pointer group">
              <div className="aspect-[16/9] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-5">
                <span className="inline-block px-2.5 py-1 rounded-md bg-accent-100 text-accent-700 text-xs font-medium mb-3 whitespace-nowrap">
                  {item.tag}
                </span>
                <h3 className="font-heading text-base md:text-lg text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2">{item.desc}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}